// Their PDPs always show a flat "Made To Order" when out of stock.
const MADE_TO_ORDER_VENDORS = ["three stories jewelry"];

class InventoryStatus extends HTMLElement {
    // current sku and orderQuantity to prevent unnecessary fetches
    lastFetchedSKU = null
    lastFetchedOrderQuantity = null

    // re-run when element is added to DOM or when observed attributes change
    connectedCallback() {
        const rootElement = this;

        // get sku
        const sku = rootElement.getAttribute("data-sku");
        const orderQuantity = rootElement.getAttribute("data-order-quantity");
        const location = rootElement.getAttribute("data-location") || ""
        const vendor = rootElement.getAttribute("data-vendor") || "";

        // placements that only want the label opt out of the icon
        const hideIcon = rootElement.hasAttribute("data-hide-icon");

        // if both are not present, exit
        if (!sku || !orderQuantity) {
            rootElement.innerHTML = "";
            return;
        }

        // if sku and orderQuantity are the same as last time, exit
        if (this.lastFetchedSKU === sku && this.lastFetchedOrderQuantity === orderQuantity) {
            return;
        }

        // update current sku and orderQuantity
        this.lastFetchedSKU = sku;
        this.lastFetchedOrderQuantity = orderQuantity;

        // suppress the weeks range for vendors
        const suppressRange = MADE_TO_ORDER_VENDORS.includes(vendor.trim().toLowerCase());

        // fetch inventory status
        fetch(`https://api.audryrosejewelry.com/public/get-inventory.php?sku=${sku}`)
            .then(response => response.json())
            .then(response => {
                const checkIcon = "https://cdn.shopify.com/s/files/1/0038/0121/9181/files/icon-check-circle.svg?v=1762383909";
                const handmadeIcon = "https://cdn.shopify.com/s/files/1/0038/0121/9181/files/icon-handmade.svg?v=1762383909";

                let icon = handmadeIcon;
                let label = "Made To Order";

                if (orderQuantity <= response.on_hand_minus_committed_inventory) {
                    icon = checkIcon;
                    label = "Ready to ship!";
                } else if (!suppressRange) {
                    const range = formatLeadTimeRange(response.lead_time_days);
                    if (range) {
                        label = `Made To Order: ${range}`;
                    }
                }

                let iconHTML = `<img class="inventoryStatusIcon" src="${icon}" alt="">`;

                if (hideIcon) {
                    iconHTML = "";
                }

                rootElement.innerHTML = `
                    <div class="inventoryStatus ${location}">
                        ${iconHTML}
                        <span class="inventoryStatusLabel">${label}</span>
                    </div>
                `;
            });
    }

    // list of attributes to monitor
    static get observedAttributes() {
        return ["data-sku", "data-order-quantity"];
    }

    // when an observed attribute changes, re-run the connectedCallback
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.connectedCallback();
        }
    }
}

// Build the "X-Y weeks" range from a day count.
// mid = ceil(days/7), display (mid-1)–(mid+1) with low end floored at 1.
// Returns null when we have no signal or when the lead time is past our
// publishable cap (>5 weeks / 35 days post-pad) — caller falls back to
// a generic "Made To Order" label.
function formatLeadTimeRange(days) {
    if (days === null || days === undefined) return null;
    if (days > 35) return null;

    const mid = Math.ceil(days / 7);
    const low = Math.max(1, mid - 1);
    const high = mid + 1;
    return `${low}-${high} weeks`;
}

// define the element
customElements.define("inventory-status", InventoryStatus);
